import { render, staticRenderFns } from "./ConfigProgress.vue?vue&type=template&id=794641d2&scoped=true&"
import script from "./ConfigProgress.vue?vue&type=script&lang=js&"
export * from "./ConfigProgress.vue?vue&type=script&lang=js&"
import style0 from "./ConfigProgress.vue?vue&type=style&index=0&id=794641d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794641d2",
  null
  
)

export default component.exports